module.exports = __webpack_public_path__ + "img/05.db32a9df.png";